import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Header, Grid, Segment} from 'semantic-ui-react';
import {getItemNameFromRef} from 'common/utils';
import {API_COMMENT_GET_SUCCESS} from 'common/types';
import REST from 'go/requests/rest';
import _ from 'lodash';

const COMMENTS_HEADERS = {
  tableDiscussion: 'Table discussion comments',
  panelChair: 'Panel chair comments',
};

export class ScoreSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: {
        tableDiscussion: [],
        panelChair: [],
      },
      error: false,
    };
  }

  componentDidMount() {
    const {grantId, token, finalScores, refItems} = this.props;
    if (grantId) {
      this.props.getPanelComments(token, grantId).then((res) => {
        if (res && res.type === API_COMMENT_GET_SUCCESS) {
          const groupedComments = _.groupBy(res.payload, 'task');
          _.map(groupedComments, (comments, type) => {
            if (type !== 'null') {
              this.setState({
                comments: {
                  ...this.state.comments,
                  [type]: comments,
                },
              });
            }
          });
        }
      });
    }
    if (refItems) {
      this.setState({
        refItems: refItems,
      });
    } else {
      this.getPartCodeList(finalScores);
    }
  }
  //check if refitems exists, if it doesnt then do a call to load to state
  getPartCodeList(scores) {
    let partCodes = [];
    _.forEach(scores, (score) => {
      if (score.part) {
        partCodes.push(score.part);
      }
    });

    let partCode = _.filter(_.uniq(partCodes), (part) => {
      return !_.isNaN(_.toNumber(part));
    });

    REST.ref
      .getItemsByItemCodes(this.props.token, partCode)
      .then((res) => res.json())
      .then((itemData) => {
        this.setState({
          refItems: itemData,
        });
      })
      .catch((err) => {
        console.error('Error retrieving ItemCodes from Ref');
      });
  }

  renderScoresSummary = (finalScores, refItems) => {
    const {fundingStreams, title} = this.props;
    const scoresMapping = _.map(finalScores, (part) => {
      const partName = getItemNameFromRef(part.part, refItems) || part.part;
      const projectId = _.get(
        fundingStreams,
        `${part.partId}.additionalInformation.projectName`,
        ''
      );
      return {
        partName: partName,
        preScore: part.preScore,
        panelScore: part.panelScore,
        cumulativeScore: part.cumulativeScore,
        projectId,
      };
    });
    const rows = _.map(scoresMapping, (finalScore, index) => {
      const panelScoreValue = _.isNumber(_.get(finalScore, 'panelScore'))
        ? _.round(_.get(finalScore, 'panelScore'), 2)
        : 'n/a';
      const preScoreValue = _.isNumber(_.get(finalScore, 'preScore'))
        ? _.round(_.get(finalScore, 'preScore'), 2)
        : 'n/a';
      let average;
      if (
        _.isNumber(_.get(finalScore, 'panelScore')) &&
        _.isNumber(_.get(finalScore, 'preScore'))
      )
        average = _.round(_.get(finalScore, 'cumulativeScore'), 2);
      else if (_.isNumber(_.get(finalScore, 'panelScore')))
        average = _.get(finalScore, 'panelScore');
      else if (_.isNumber(_.get(finalScore, 'preScore')))
        average = _.get(finalScore, 'preScore');
      else average = 'n/a';
      return (
        <FemaGoTable.Row key={index}>
          <FemaGoTable.TextCell>
            {finalScore.partName} {finalScore.projectId}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{panelScoreValue}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{preScoreValue}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{average}</FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });
    return (
      <React.Fragment>
        <Header id={title} name={title} as="h2">
          {title}
        </Header>
        <FemaGoTable type="static" summary="Score summary">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Activity</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Panel score average</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Pre-score</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Overall score</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>{rows}</FemaGoTable.Body>
        </FemaGoTable>
      </React.Fragment>
    );
  };

  renderComments = (comments, commentType) => {
    return (
      <Grid>
        <Grid.Row key={COMMENTS_HEADERS[commentType]}>
          <Grid.Column width="16">
            <Header as="h4">{COMMENTS_HEADERS[commentType]}</Header>
          </Grid.Column>
        </Grid.Row>
        {_.map(comments, (comment) => (
          <Grid.Row key={comment.author + comment.comment}>
            <Grid.Column width="6">{comment.author}</Grid.Column>
            <Grid.Column width="10">
              <strong>{comment.comment}</strong>
            </Grid.Column>
          </Grid.Row>
        ))}
      </Grid>
    );
  };

  render() {
    const {comments, refItems} = this.state;
    const {finalScores, hideTable} = this.props;

    return (
      <React.Fragment>
        {!_.isEmpty(finalScores) &&
          !hideTable &&
          this.renderScoresSummary(finalScores, refItems)}
        {(_.size(comments.tableDiscussion) > 0 || _.size(comments.panelChair) > 0) &&
          _.map(
            comments,
            (comment, commentType) =>
              !_.isEmpty(comment) && (
                <Segment key={comment.id}>
                  {this.renderComments(comment, commentType)}
                </Segment>
              )
          )}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getPanelComments: (token, grantId) =>
    dispatch(ApiActions.comments.getCommentsForGrant(token, grantId)),
});

export default connect(null, mapDispatchToProps)(connectWithCore(ScoreSummary));
